module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('TopNavFooter', [_c('div', {
    staticClass: "main-content",
    attrs: {
      "id": "admin"
    }
  }, [_c('spinner', {
    attrs: {
      "spinnerOn": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "background": "#fff",
      "padding": "0px",
      "padding-top": "35px"
    }
  }, [_c('div', {
    staticClass: "modal deleteConfirmModal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "font-weight": "bold",
      "float": "left",
      "width": "90%"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.delete))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "background": "#ffffff !important",
      "color": "#000 !important"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.wanttodeleteadminconfig) + " ")])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.removeConfirm()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.yes))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.no))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal cannotDeleteModal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block",
      "border": "0px !important"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "float": "left",
      "width": "90%",
      "margin": "10px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.cannotdeleteconfig))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "background": "#ffffff !important",
      "color": "#000 !important"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "margin": "-15px"
    }
  }, [_c('div', {
    staticClass: "bc-adduser"
  }, [_c('div', {
    staticStyle: {
      "font-size": "44px !important",
      "font-weight": "bold",
      "overflow": "auto",
      "margin-bottom": "15px"
    }
  }, [_c('span', [_vm._v("API Settings")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "margin": "10px 0px"
    }
  }, [_vm._v("\n\t  Note: This section is to provide applications to use one cargill APIs.")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 configGroupAdmin table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('th', [_vm._v("Allowed Application")]), _vm._v(" "), _c('th', [_vm._v("Brand")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Allowed groups")]), _vm._v(" "), _c('th', [_vm._v(" ")])]), _vm._v(" "), _vm._l((_vm.appAdminGroupModal), function(i, index) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "min-width": "250px"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appAdminGroupModal[index].applicationId),
        expression: "appAdminGroupModal[index].applicationId"
      }],
      class: {
        disabledLight: _vm.appAdminGroupModal[index].applicationId !== undefined &&
          _vm.appAdminGroupModal[index].applicationId !== 'undefined' && _vm.appAdminGroupModal[index].groupId !== ''
      },
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "id": 'select' + i.applicationId
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.appAdminGroupModal[index].applicationId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getGroups(i.applicationId)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": "undefined"
      }
    }, [_vm._v(_vm._s(_vm.user_lang.selectapp))]), _vm._v(" "), _vm._l((_vm.appList), function(j) {
      return (j.name !== 'bookmark') ? _c('option', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (i.appGrpId === undefined),
          expression: "i.appGrpId === undefined"
        }],
        domProps: {
          "value": j.id
        }
      }, [_vm._v(_vm._s(j.label))]) : _vm._e()
    })], 2)]), _vm._v(" "), _c('td', {
      staticStyle: {
        "min-width": "200px"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appAdminGroupModal[index].brand),
        expression: "appAdminGroupModal[index].brand"
      }],
      class: {
        disabledLight: _vm.appAdminGroupModal[index].applicationId !== undefined &&
          _vm.appAdminGroupModal[index].applicationId !== 'undefined' && _vm.appAdminGroupModal[index].groupId !== ''
      },
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "id": 'selectbrand' + i.applicationId
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.appAdminGroupModal[index].brand = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "undefined"
      }
    }, [_vm._v(_vm._s(_vm.user_lang.selectBrand))]), _vm._v(" "), _vm._l((_vm.brandDetails.data), function(j) {
      return _c('option', {
        domProps: {
          "value": j.brandKey
        }
      }, [_vm._v(_vm._s(j.brandName))])
    })], 2)]), _vm._v(" "), _c('td', {
      staticStyle: {
        "min-width": "250px"
      }
    }, [_c('div', {
      attrs: {
        "id": "dropdown"
      }
    }, [_c('div', {
      staticClass: "selectDropDown",
      on: {
        "click": function($event) {
          _vm.openDropDown(index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "padding-left": "5px"
      }
    }, [(_vm.appAdminGroupModal[index].subGroupId && _vm.appAdminGroupModal[index].subGroupId.length == 0) ? _c('span', [_vm._v("\n\t\t\t" + _vm._s(_vm.user_lang['selectgroupslist']) + " ")]) : _vm._e(), _vm._v(" "), (_vm.appAdminGroupModal[index].subGroupId && _vm.appAdminGroupModal[index].subGroupId.length > 0) ? _c('span', [_vm._v("\n\t\t\tSelected (" + _vm._s(_vm.appAdminGroupModal[index].subGroupId ? _vm.appAdminGroupModal[index].subGroupId.length : '0') + ")")]) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "fa fa-caret-down",
      staticStyle: {
        "float": "right",
        "margin": "4px 5px",
        "margin-top": "-10px"
      }
    })])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showDropDown[index.toString()]),
        expression: "showDropDown[index.toString()]"
      }],
      class: 'ddwrap' + index,
      attrs: {
        "id": "checkboxlist"
      }
    }, [_vm._l((_vm.appsGroups[i.applicationId]), function(j) {
      return _c('div', {
        staticClass: "dd-list-item",
        staticStyle: {
          "padding-right": "15px",
          "padding-left": "5px"
        }
      }, [_c('input', {
        staticClass: "form-control input-checkbx-sub",
        attrs: {
          "id": j.id + '~' + index,
          "type": "checkbox"
        },
        domProps: {
          "value": j.id
        },
        on: {
          "change": function($event) {
            _vm.checkchange($event)
          }
        }
      }), _vm._v(" "), _c('label', {
        staticStyle: {
          "vertical-align": "super"
        },
        attrs: {
          "for": j.id
        }
      }, [_vm._v(_vm._s(j._embedded.group.profile.name))])])
    }), _vm._v(" "), _vm._l((_vm.appAdminGroupModal[index].subGroupId), function(j) {
      return (j.indexOf('~~~') > -1 && _vm.appGroupsArrayMap[i.applicationId].indexOf(j.split('~~~')[0]) === -1) ? _c('div', {
        staticClass: "dd-list-item",
        staticStyle: {
          "padding-right": "15px",
          "padding-left": "5px"
        }
      }, [_c('input', {
        staticClass: "form-control input-checkbx-sub",
        attrs: {
          "id": j.split('~~~')[0] + '~' + index,
          "type": "checkbox"
        },
        domProps: {
          "value": j.split('~~~')[0]
        },
        on: {
          "change": function($event) {
            _vm.checkchange($event)
          }
        }
      }), _vm._v(" "), _c('label', {
        staticStyle: {
          "vertical-align": "super"
        },
        attrs: {
          "for": j.split('~~~')[0]
        }
      }, [_vm._v(_vm._s(j.split('~~~')[1]))])]) : _vm._e()
    })], 2)]), _vm._v(" "), _vm._l((_vm.appsGroups[i.applicationId]), function(j) {
      return (_vm.appAdminGroupModal[index].subGroupId && _vm.appAdminGroupModal[index].subGroupId.indexOf(j.id) > -1) ? _c('span', {
        staticStyle: {
          "display": "block"
        }
      }, [_vm._v("-" + _vm._s(j._embedded.group.profile.name))]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.appAdminGroupModal[index].subGroupId), function(j) {
      return (j.indexOf('~~~') > -1 && _vm.appGroupsArrayMap[i.applicationId].indexOf(j.split('~~~')[0]) === -1) ? _c('span', {
        staticStyle: {
          "display": "block"
        }
      }, [_vm._v("-" + _vm._s(j.split('~~~')[1]))]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "font-weight": "bold",
        "margin-top": "5px"
      }
    }, [_vm._v("Add additional group:")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.additionalGroup[index]),
        expression: "additionalGroup[index]"
      }],
      staticClass: "addgrouptxtbox",
      attrs: {
        "type": "text",
        "placeholder": "Enter group name and click +"
      },
      domProps: {
        "value": (_vm.additionalGroup[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.additionalGroup, index, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-plus-circle",
      staticStyle: {
        "font-size": "20px",
        "cursor": "pointer",
        "color": "rgb(101, 141, 27)",
        "margin-left": "10px"
      },
      on: {
        "click": function($event) {
          _vm.addAdditionalGroup(index, i.applicationId)
        }
      }
    })], 2), _vm._v(" "), _c('td', {
      staticStyle: {
        "min-width": "80px"
      }
    }, [_c('button', {
      staticClass: "deleteconfig",
      on: {
        "click": function($event) {
          _vm.removeRow(i.appGrpId, index, i.applicationId)
        }
      }
    }, [_vm._v("Delete")])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isIncomplete),
      expression: "isIncomplete"
    }],
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "15px",
      "color": "red"
    }
  }, [_vm._v("\n\t  " + _vm._s(_vm.user_lang.adminConfigIncomplete))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.saveSuccess),
      expression: "saveSuccess"
    }],
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "15px",
      "color": "green"
    }
  }, [_vm._v("\n\t  " + _vm._s(_vm.user_lang.adminconfigupdatesuccess))]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deleteSuccess),
      expression: "deleteSuccess"
    }],
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "15px",
      "color": "green"
    }
  }, [_vm._v("\n\t  " + _vm._s(_vm.user_lang.adminconfigdeletesuccess))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticStyle: {
      "margin-right": "15px",
      "line-height": "16px",
      "cursor": "pointer",
      "font-size": "17px",
      "border-radius": "2px"
    },
    on: {
      "click": function($event) {
        _vm.saveAdminGroups()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.save))]), _vm._v(" "), _c('button', {
    staticStyle: {
      "margin-right": "15px",
      "line-height": "16px",
      "cursor": "pointer",
      "border-radius": "2px"
    },
    on: {
      "click": function($event) {
        _vm.addConfigRow()
      }
    }
  }, [_vm._v("Add New App")])])])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-cf5396ea", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf5396ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/APISettingsOld.vue
// module id = 720
// module chunks = 1